import { type GkAirRecommendedProductWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import {
  udpTrackingBuildProductImpression,
  type UdpTrackingProductImpression,
} from '../../udp-tracking'

import { recommendationUdpTrackingBuildProduct } from './recommendationUdpTrackingBuildProduct'

export const recommendationUdpTrackingBuildProductImpression = ({
  isSponsored,
  position,
  product,
  recommendationId,
  widgetId,
}: {
  isSponsored: boolean
  position: number
  product: GkAirRecommendedProductWeb
  recommendationId: string
  widgetId: string
}): UdpTrackingProductImpression | undefined => {
  if (!recommendationId || !widgetId || position < 1) {
    return undefined
  }

  return udpTrackingBuildProductImpression({
    impressionOrigin: 'recommendation',
    impressionOriginData: {
      position,
      recommendation_id: recommendationId,
      tracking_token: product.attributes.trackingtoken ?? null,
      widget_id: widgetId,
    },
    product: recommendationUdpTrackingBuildProduct({
      isSponsored,
      product: product.data,
    }),
  })
}
